import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Sidebar from "./Sidebar";
import Header from "./Header";
import Footer from "./Footer";

export const RateTemplateList = () => {
  const [rateTemplates, setRateTemplates] = useState([]);
  const navigate = useNavigate();

  const handleToggle = async (templateId, isActivate) => {
    console.log("Toggle button clicked for template ID:", templateId);
    console.log("Is Activate:", isActivate);

    const apiUrl = "https://api.kalmesh.in/BabyStepsAPI/active-deactive-rate";

    try {
      const apiToken = sessionStorage.getItem("api_token");

      if (!apiToken) {
        console.error("API Token not found in session storage");
        // Handle the case where the API token is not found
        return;
      }

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          su_id: 1,
          api_token: apiToken,
          template_id: templateId,
          is_activate: isActivate ? 1 : 0,
          trans_from: "SUPER_ADMIN",
        }),
      });

      console.log(response);

      if (response.ok) {
        const updatedTemplates = rateTemplates.map((template) => {
          if (template.id === templateId) {
            return { ...template, is_activate: isActivate ? 1 : 0 };
          }
          return template;
        });

        setRateTemplates(updatedTemplates);

        // Manually initiate a page reload
        window.location.reload();
      } else {
        console.error("Failed to update template activation status");
      }
    } catch (error) {
      console.error("Error occurred while updating template", error);
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      const apiUrl = "https://api.kalmesh.in/BabyStepsAPI";

      try {
        const apiToken = sessionStorage.getItem("api_token");

        if (!apiToken) {
          console.error("API Token not found in session storage");
          // Handle the case where the API token is not found
          return;
        }

        const response = await fetch(`${apiUrl}/rate-template-list`, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams({
            su_id: 1,
            api_token: apiToken,
            trans_from: "SUPER_ADMIN",
          }),
        });

        if (response.ok) {
          const data = await response.json();
          console.log(data);
          setRateTemplates(data.data.reverse());
        } else {
          console.error("Failed to fetch data");
        }
      } catch (error) {
        console.error("Error occurred while fetching data", error);
      }
    };

    fetchData();
  }, []); // Empty dependency array to run the effect only once on component mount

  return (
    <>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header />
            <div className="container-fluid">
              <h1 className="h3 mb-4 text-gray-800">Rate Template List</h1>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Rate Template List
                  </h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered"
                      id="dataTable"
                      width="100%"
                      cellSpacing={0}
                    >
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Pin-Code</th>
                          <th>Month</th>
                          <th>Rate</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(rateTemplates) && rateTemplates.length > 0 ? (
                          rateTemplates.map((template) => (
                            <tr key={template.id}
                            style={{
                              backgroundColor: template.activated === "1" ? "white" : "#FAFAFA",
                              color: template.activated === "1" ? "black" : "red",
                             
                            }}>
                              <td>{template.id}</td>
                              <td>{template.pincode}</td>
                              <td>{template.months}</td>
                              <td>{template.rate}</td>
                              <td>
                                <button
                                  className="btn btn-link"
                                  onClick={() => navigate(`/updateratetemplete/${template.id}`)}
                                >
                                  <i className="fa fa-edit"></i>
                                </button>
                                {/* // Button section inside map function */}
                                <button
                                  type="button" // Instead of type="submit"
                                  style={{ 
                                    backgroundColor: template.activated === "1" ? "white" : "#FAFAFA",
                                     border: "none", color: "red", fontSize:"20px" }}
                                  onClick={() => handleToggle(template.id, template.activated !== "1")}
                                >
                                  {template.activated === "1" ? (
                                    <i className="fa fa-toggle-on" style={{backgroundColor: "white", color: "green"}}></i>
                                  ) : (
                                    <i className="fa fa-toggle-off"></i>
                                  )}
                                </button>


                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5">No data available</td>
                          </tr>
                        )}
                      </tbody>

                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};
